<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  index: number;
  baseSequence: number | string;
  starData: { sk: string; sf: string; sb: string };
  aptStar: { year: number; month: number } | null;
}>();

const starOptions = {
  fontSize: 18,
  fontStyle: 700,
  fontFamily: "SF Pro Text, sans-serif",
  align: "center",
};

const currentStarCircleConfig = {
  radius: 13,
  stroke: "#000000",
  strokeWidth: 1,
};
</script>

<template>
  <v-group>
    <!-- 1. Верхняя надпись: например "5-12" -->
    <v-text
      :x="-26"
      :y="-48"
      :config="{
        text: `${baseSequence}`,
        fontSize: 16,
        fontStyle: 700,
        fontFamily: 'SF Pro Text, sans-serif',
      }"
      fill="#000000"
      align="center"
      :width="56"
    />

    <!-- 2. Основной блок звезды -->
    <v-group :x="-28" :y="-28">
      <!-- Фон для звезды (если нужен) -->
      <v-rect
        :x="0"
        :y="0"
        :width="56"
        :height="56"
        stroke="#9C9592"
        fill="#FFFFFF"
        :stroke-width="1"
        corner-radius="20px"
      />

      <v-text
        :x="-14"
        :y="6"
        :text="starData.sk"
        :config="starOptions"
        :width="56"
      />

      <v-text
        :x="14"
        :y="6"
        :text="starData.sf"
        :config="starOptions"
        :width="56"
      />

      <v-text
        :x="0"
        :y="32"
        :text="starData.sb"
        :config="starOptions"
        :width="56"
      />
    </v-group>

    <!-- 3. Блок с Apt Star (год + месяц) -->
    <v-group v-if="aptStar" :x="26" :y="0">
      <!-- Year -->
      <v-circle
        :x="20"
        :y="-16"
        :config="currentStarCircleConfig"
        :fill="aptStar.year == 5 ? '#EE441A' : '#FFFFFF'"
      />
      <v-text
        :x="15"
        :y="-25"
        :text="aptStar.year.toString()"
        :fill="aptStar.year == 5 ? '#FFFFFF' : '#000000'"
        :config="starOptions"
      />

      <!-- Month -->
      <v-circle
        :x="20"
        :y="16"
        :config="currentStarCircleConfig"
        :fill="aptStar.month == 5 ? '#EE441A' : '#FFFFFF'"
      />
      <v-text
        :x="15"
        :y="7"
        :text="aptStar.month.toString()"
        :fill="aptStar.month == 5 ? '#FFFFFF' : '#000000'"
        :config="starOptions"
      />
    </v-group>
  </v-group>
</template>

<style scoped></style>
